import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-pascal-case */

/* Original name @uswitch/trustyle.card */
import { Link } from '@uswitch/ev-core/react';
import { ConditionalWrapper } from '@uswitch/ev-utils/conditional-wrapper';
import dayjs from '@uswitch/ev-utils/trustyle-date';
import { Type } from '@uswitch/spark';
import * as React from 'react';
import { Themed } from 'theme-ui';
import { ButtonLink } from '../button-link';
import ImgixImg from '../imgix-img';
import { DynamicSparkIcon } from '../spark-icons/dynamic-spark-icon';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var makeStyles = function makeStyles(variant) {
  return function (element) {
    return "compounds.card.variants.".concat(variant).concat(element ? ".".concat(element) : '');
  };
};

var Card = function Card(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$critical = _ref.critical,
      critical = _ref$critical === void 0 ? false : _ref$critical,
      date = _ref.date,
      description = _ref.description,
      _ref$imageSize = _ref.imageSize,
      imageSize = _ref$imageSize === void 0 ? 'cover' : _ref$imageSize,
      imgAlt = _ref.imgAlt,
      _ref$imgSizes = _ref.imgSizes,
      imgSizes = _ref$imgSizes === void 0 ? '768px' : _ref$imgSizes,
      imgSrc = _ref.imgSrc,
      _ref$imageProps = _ref.imageProps,
      imageProps = _ref$imageProps === void 0 ? {} : _ref$imageProps,
      linkHref = _ref.linkHref,
      linkIcon = _ref.linkIcon,
      linkText = _ref.linkText,
      superScript = _ref.superScript,
      tag = _ref.tag,
      title = _ref.title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'vertical' : _ref$variant,
      headerChildren = _ref.headerChildren,
      contentChildren = _ref.contentChildren,
      button = _ref.button,
      sys = _ref.sys,
      name = _ref.name;
  var styles = makeStyles(variant);
  var isAspectRatioBox = variant === 'vertical' || variant === 'horizontal';

  var HeaderWrapper = function HeaderWrapper(children) {
    return headerChildren ? _jsxs("div", {
      sx: {
        variant: styles('headerChildren')
      },
      children: [_jsx("div", {
        sx: {
          variant: styles('headerChildren')
        },
        children: headerChildren
      }), _jsx("span", {
        children: children
      })]
    }) : children;
  };

  var AspectRatioWrapper = function AspectRatioWrapper(children) {
    return isAspectRatioBox ? _jsx("div", {
      sx: {
        variant: styles('aspectRatioWrapper')
      },
      children: _jsx(ConditionalWrapper, {
        condition: linkHref,
        wrapper: Link,
        sx: {
          variant: styles('image')
        },
        otherwise: function otherwise(_ref2) {
          var children = _ref2.children,
              props = _objectWithoutProperties(_ref2, _excluded);

          return _jsx("span", _objectSpread(_objectSpread({}, props), {}, {
            children: children
          }));
        },
        href: linkHref,
        sys: sys,
        name: name,
        children: _jsx("div", {
          sx: {
            variant: styles('aspectRatioBox')
          },
          children: _jsx("div", {
            sx: {
              variant: styles('cardImage'),
              width: '100%'
            },
            children: children
          })
        })
      })
    }) : _jsx(ConditionalWrapper, {
      condition: linkHref,
      wrapper: Link,
      otherwise: function otherwise(_ref3) {
        var children = _ref3.children,
            props = _objectWithoutProperties(_ref3, _excluded2);

        return _jsx("span", _objectSpread(_objectSpread({}, props), {}, {
          children: children
        }));
      },
      sx: {
        variant: styles('image')
      },
      href: linkHref,
      sys: sys,
      name: name,
      children: children
    });
  };

  var journeyVariant = variant === 'journey-card';

  var JourneyButton = _jsx(ButtonLink, {
    variant: "primary-journey",
    href: linkHref,
    afterIcon: linkIcon,
    sys: sys,
    name: name,
    children: linkText
  });

  return _jsxs("div", {
    className: className,
    sx: {
      variant: styles()
    },
    children: [HeaderWrapper(AspectRatioWrapper(_jsx(ImgixImg, _objectSpread(_objectSpread({
      alt: imgAlt,
      src: imgSrc,
      sizes: imgSizes,
      critical: critical,
      ctfToUswitchContenftul: false,
      clearPx: false,
      imgixAutoFormatCompress: false,
      svgAsImg: false
    }, imageProps), {}, {
      imgixParams: _objectSpread({
        fit: imageSize === 'cover' ? 'crop' : 'fill',
        crop: 'faces,entropy',
        ar: '16:9',
        fill: 'solid'
      }, imageProps.imgixParams || {})
    })))), _jsxs("div", {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        variant: styles('content')
      },
      children: [_jsxs("div", {
        sx: {
          display: 'flex',
          alignItems: 'baseline',
          variant: styles('meta')
        },
        children: [date && _jsx(Themed.p, {
          as: "div",
          sx: {
            variant: styles('date')
          },
          children: dayjs(date).format('DD MMMM YYYY')
        }), tag && _jsx("span", {
          sx: {
            marginRight: 'sm',
            variant: styles('tag')
          },
          children: tag
        }), superScript && _jsx(Themed.p, {
          as: "div",
          sx: {
            variant: styles('superScript')
          },
          children: _jsx("p", {
            children: superScript
          })
        }), contentChildren && _jsx("div", {
          sx: {
            variant: styles('contentChildren')
          },
          children: contentChildren
        })]
      }), title && _jsx(Type.H4, {
        as: "h3",
        sx: {
          margin: '0',
          variant: styles('heading')
        },
        children: _jsx(ConditionalWrapper, {
          condition: linkHref,
          wrapper: Link,
          otherwise: function otherwise(_ref4) {
            var children = _ref4.children,
                props = _objectWithoutProperties(_ref4, _excluded3);

            return _jsx("span", _objectSpread(_objectSpread({}, props), {}, {
              children: children
            }));
          },
          href: linkHref,
          sys: sys,
          name: name,
          children: title
        })
      }), description && _jsx(Themed.p, {
        sx: {
          variant: styles('description')
        },
        children: description
      }), linkText && !journeyVariant && _jsxs(ConditionalWrapper, {
        condition: linkHref,
        wrapper: Link,
        otherwise: function otherwise(_ref5) {
          var children = _ref5.children,
              props = _objectWithoutProperties(_ref5, _excluded4);

          return _jsx("span", _objectSpread(_objectSpread({}, props), {}, {
            children: children
          }));
        },
        sx: {
          textDecoration: 'underline',
          variant: styles('link')
        },
        href: linkHref,
        sys: sys,
        name: name,
        children: [linkIcon && _jsx(DynamicSparkIcon, {
          glyph: linkIcon,
          color: "brand"
        }), linkText]
      }), linkText && journeyVariant && (button && button || JourneyButton)]
    })]
  });
};

export default Card;
//# sourceMappingURL=index.js.map